import { type ComponentType, type LazyExoticComponent } from 'react';

import { lazyWithRetry } from '../utils/lazyWithRetry';

// Same constraint React.lazy itself uses, so the lazy component keeps the
// wrapped component's props.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyComponent = ComponentType<any>;

/**
 * Lazy-load a named export (with chunk-load retry). Route tables use it so a
 * page module, and everything it pulls in, is only downloaded when its route
 * first renders, while the route array itself stays a static, analyzable
 * declaration.
 */
export const lazyNamed = <M extends Record<K, AnyComponent>, K extends keyof M>(
  load: () => Promise<M>,
  name: K,
): LazyExoticComponent<M[K]> => lazyWithRetry(async () => ({ default: (await load())[name] }));
